<template>
  <div>
    <div class="activityContent">
      <div class="activityLi" v-for="(item, index) in dataSource" :key="index" @click="onActivity(item.id)">

        <span class="tipCon tipconOn" v-if="item.isFinish == 1 && diffTime(item.signendTime)"></span>
        <span class="tipCon" v-else></span>
        <div class="activityImg">
          <img v-if="item.logo" style="width: 100%;height: 100%;" :src="getImg(item.logo)" />
          <img v-else src="@/assets/img/defaultPhotoLong.png" style="width: 100%;height: 100%;" alt="">
        </div>
        <div class="activityInfoTitle">
          {{ item.title }}
        </div>
        <div class="activityInfoTime">
          报名时间：{{ item.activityTime && item.activityTime.split(' ')[0] }} ~ {{
            item.signendTime && item.signendTime.split(' ')[0] }}
        </div>
        <div class="activityInfoTime">
          活动时间：{{ item.startDate && item.startDate.split(' ')[0] }} ~ {{ item.endDate && item.endDate.split(' ')[0] }}
        </div>
        <div class="activityInfoAddress">
          地址：{{ item.address }}
        </div>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
    </div>
  </div>
</template>
<script>
import { activity } from "@/api/innovationService";
import { file_service } from "@/api/adminService";
import { listMixin } from "@/mixins";

export default {
  name: 'innovationBigData',
  mixins: [listMixin],
  data() {
    return {
      activityData: [],
      queryParam: {},
      listUrl: activity.pageList,
      current: 1,
      pageSize: 12,
    }
  },
  methods: {
    diffTime(endtime) {
			let now = new Date() //当前时间
			//如果传2022-02-22 14:15:00要转化成 2022/02/22 14:15:00
			let end = new Date(endtime.replace(/-/g, "/")) //对比时间
			if (now.getTime() > end.getTime()) {
				//当前时间比指定时间大
				return false
			} else {
				//小于指定时间
				return true
			}
		},
    //活动详情
    onActivity(id) {
      this.$router.push({
        path: "/Innovation/components/activeryDetail",
        query: { id: id, type: "资讯公告" }
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
  }
}
</script>
<style scoped lang="less">
.activityContent {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;

    .activityLi {
      .tipCon{
        position: absolute;
        top:-2px;
        left:-2px;
        width:55px;
        height:55px;
        background: url(../../../assets/img/signendOff.png);
      }
      .tipconOn{
        background: url(../../../assets/img/signendOn.png);
      }
      position: relative;
      width: 23%;
      margin: 20px 32px 20px 0;
      cursor: pointer;
      border: 1px solid #dedede;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .activityImg {
        width: 100%;
        height: 180px;
      }

      .activityInfoTitle {
        padding: 15px 10px;
        font-size: 16px;
        color: #333;
      }

      .activityInfoTime {
        overflow: hidden;
        padding: 5px 10px;
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }

      .activityInfoAddress {
        overflow: hidden;
        padding: 5px 10px 20px 10px;
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }

    .activityLi:hover {
      //box-shadow: 5px 5px 10px 10px #f1f1f1;
      //transition: all 0.5s ease 0s;
      border: none;
      -webkit-transition: all 0.3s ease 0s;
      transition: all 0.3s ease 0s;
      //border: 1px solid #ffffff;
      cursor: pointer;
      -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
      box-shadow: 0 5px 10px 1px #d2e6ff;
      //.activityInfoTitle {
      //	color: #fff;
      //	background-color: #2162e4;
      //
      //}
      //
      //.activityInfoTime {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
      //
      //.activityInfoAddress {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
    }
  }
.pagination {
  text-align: center;
  margin-bottom: 20px;
}
</style>
